// const MAIN_URL = "http://144.91.100.115:8444";
const MAIN_URL = "https://service.orthomagic.com.tr:8447";
export { MAIN_URL };
